import { Icon } from './Icon';
import { AssetTypeWithIcon, IconSize } from './types';
import { getColorForAssetType, getIconNameForAssetType } from './utils';

type AssetTypeIconProps = {
  assetType: AssetTypeWithIcon;
  tooltipText?: string;
};

export const AssetTypeIcon = ({
  assetType,
  tooltipText,
}: AssetTypeIconProps) => {
  return (
    <Icon
      iconSize={IconSize.MEDIUM}
      iconName={getIconNameForAssetType(assetType)}
      color={getColorForAssetType(assetType)}
      data-tooltip-text={tooltipText}
    />
  );
};
